import { createMockTag } from 'dashboard/lib/stubs/tag';
import { Tag, TagAttributes } from 'dashboard/models/tag';

export function createPreviewTag(attributes?: Partial<TagAttributes>, id?: string): Tag {
  return createMockTag(attributes, id);
}
